import { useEffect } from 'react';
import { getWeeklyVersionUGCVideo } from '@op/services';
import { useTablePropsInfo } from '@op/hooks/common';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { DBO_REQ } from '@op/utils/format';

const renderKeys = [
  { key: 'view', maxKey: 'max_views' },
  { key: 'engagement', maxKey: 'max_engagements' },
  { key: 'follower_number', maxKey: 'max_followers' },
  { key: 'tweets_reply', maxKey: 'max_comments' },
];
const keys = renderKeys.map((item) => item.key);

export function useVersionVideo({ filter }: { filter: any }) {
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: false,
  });

  const { total, setTotal, data, setData, sortBy, setSortBy } =
    useTablePropsInfo({
      defaultPageInfo: { page: 1, page_size: 10 },
      defaultSortBy: { by: 'view', order: 'desc' },
    });

  function getVideoTableData() {
    setData([]);
    setTotal(0);

    // 接口、params（待改）
    wrapperCancelRequest(getWeeklyVersionUGCVideo, filter)
      .then((data: any) => {
        const { list, total, max_stats } = data || {}; 

        const tableData = DBO_REQ.singleTable(list, {
          hasQOQ: false,
          hasRATIO: true,
          totalMap: renderKeys.reduce((acc, cur) => {
            const { key, maxKey } = cur;
            return { ...acc, [key]: Number(max_stats?.[maxKey]) || 0 };
          }, {}),
          keys,
        }); 
        setData(tableData);
        setTotal(total || 0);
      })
      .catch((e) => console.log(e));
  }

  // 当筛选条件变化时候重新获取表单数据
  useEffect(() => {
    if (!filter) {
      return;
    }
    getVideoTableData();
  }, [filter]);

  return {
    loading,
    data,
    total,
    sortBy,
    setSortBy,
    keys,
  };
}
